import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme: any) => ({
  stickyHeader: {
    position: "sticky",
    top: 0,
    backgroundColor: "white",
    zIndex: 10,
    paddingBottom: "20px",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "20px 0 0 0",
    gap: "15px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "10px",
    },
  },
  box: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
  },
  boxText: {
    fontFamily: "Poppins",
    fontWeight: 800,
    color: "#4D1277",
    fontSize: "24px",
    letterSpacing: "-0.5px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  backButton: {
    color: "#4D1277",
    backgroundColor: "#4D127708",
    padding: "8px",
    "&:hover": {
      backgroundColor: "#4D127715",
    },
  },
  responseActionStyle: {
    fontFamily: "Poppins",
    fontWeight: 600,
    borderRadius: "12px",
    padding: "18px 10px",
    border: "1px solid #4D127722",
    color: "#4D1277",
    backgroundColor: "#4D127705",
    "& .MuiChip-icon": {
      color: "#4D1277",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "15px 8px",
      fontSize: "12px",
    },
  },
  cardContent: {
    padding: "0 !important",
    marginTop: "10px",
  },
  bottomBox: {
    background: "#ffffff",
    borderRadius: "20px",
    padding: "30px",
    border: "1px solid #f0f0f0",
    boxShadow: "0 10px 30px rgba(0,0,0,0.03)",
    maxWidth: "800px",
    margin: "10px 0",
    [theme.breakpoints.down("sm")]: {
      padding: "20px",
      borderRadius: "15px",
    },
  },
  typeText: {
    fontFamily: "Poppins",
    fontWeight: 700,
    fontSize: "14px",
    color: "#2d3436",
    marginBottom: "8px",
  },
  fieldStyle: {
    width: "100%",
    color: "#272525",
    fontSize: "14px",
    fontWeight: 500,
    fontFamily: "Poppins",
    borderRadius: "12px !important",
    backgroundColor: "#fcfcfc",
    transition:
      "border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #e0e0e0 !important",
      borderRadius: "12px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#4D127744 !important",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "2px solid #4D1277 !important",
    },
    "& .MuiSelect-select": {
      padding: "12px 16px",
      display: "flex",
      alignItems: "center",
    },
  },
  textArea: {
    borderRadius: "12px",
    border: "1px solid #e0e0e0",
    padding: "18px",
    fontFamily: "Poppins",
    fontSize: "15px",
    width: "100%",
    outline: "none",
    backgroundColor: "#fcfcfc",
    transition:
      "border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease",
    marginTop: "10px",
    "&:hover": {
      borderColor: "#4D127744",
    },
    "&:focus": {
      borderColor: "#4D1277",
      backgroundColor: "#fff",
      boxShadow: "0 4px 12px rgba(77, 18, 119, 0.05)",
    },
    resize: "none",
    "&::placeholder": {
      color: "#b2bec3",
    },
  },
  savebutton: {
    borderRadius: "12px",
    background: "linear-gradient(135deg, #4D1277 0%, #8e44ad 100%)",
    textTransform: "none",
    fontFamily: "Poppins",
    fontWeight: 700,
    fontSize: "16px",
    color: "#fff !important",
    padding: "14px 40px",
    boxShadow: "0 8px 20px rgba(77, 18, 119, 0.25)",
    transition: "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
    marginTop: "10px",
    "&:hover": {
      background: "linear-gradient(135deg, #5b1a8d 0%, #9b59b6 100%)",
      boxShadow: "0 12px 28px rgba(77, 18, 119, 0.35)",
      transform: "translateY(-2px)",
    },
    "&:active": {
      transform: "translateY(0)",
    },
    "&.Mui-disabled": {
      background: "linear-gradient(135deg, #4D1277 0%, #8e44ad 100%)",
      opacity: 0.8,
      color: "#ffffffCC !important",
      "& .MuiCircularProgress-root": {
        color: "#ffffff !important",
      },
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: "12px 20px",
    },
  },
  formikText: {
    fontWeight: "500",
    fontFamily: "Poppins",
    fontSize: "12px",
    marginTop: "4px",
    minHeight: "20px",
  },
}));

export default useStyles;
